/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './functions.php',
    './404.php',
    './archive.php',
    './comments.php',
    './footer.php',
    './header.php',
    './index.php',
    './front-page.php',
    './page.php',
    './search.php',
    './sidebar.php',
    './single.php',

    './theme-templates/*.php',
    './page-templates/*.php',
    './template-parts/**/*.php',
    './alm_templates/**/*.php',
    './components/**/*.php',

    './snippets/**/*.html',
    
    './assets/src/js/**/*.js',
    './assets/src/img/*.svg'
  ],
  safelist: [
    {
      pattern: /block/,
      variants: ['xs', 'sm', 'md', 'ml', 'lg', 'lgr', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl', 'hover', 'focus'],
    },
  ],
  theme: {
    screens: {
      'xs': '425px',
			'sm': '640px',
			'md': '768px',
			'ml': '960px',
			'lg': '1024px',
      'lgr': '1140px',
			'xl': '1280px',
			'2xl': '1360px',
			'3xl': '1440px',
			'4xl': '1680px',
			'5xl': '1920px',
			'6xl': '2160px',
			'7xl': '2320px',
			'8xl': '2560px',
			'9xl': '2800px',
			'mouse': { 'raw': '(any-hover: hover)' },
			'touch': { 'raw': '(any-hover: none)' },
      'short': { 'raw': '(max-height: 900px)' },
      'portrait': { 'raw': '(orientation: portrait)' },
    },
    fontFamily: {
			'head': ['arponasans'],
			'body': ['bely'],
			'arponasans': ['arponasans'],
			'bely': ['bely'],
		},
    fontSize: {
      'xs': ['.75rem', '1rem'],
			'sm': ['.875rem', '1.25rem'],
			'base': ['1rem', '1.5rem'],
			'lg': ['1.125rem', '1.5rem'],
			'xl': ['1.25rem', '1.75rem'],
      '2xl': ['1.5rem', '1.75rem'],
			'3xl': ['1.875rem', '2rem'],
			'4xl': ['2.25rem', '2.5rem'],
			'5xl': ['2.5rem', '1.15'],
			'6xl': ['3rem', '1.15'],
			'7xl': ['3.75rem', '1.15'],
			'8xl': ['4.5rem', '1.15'],
			'9xl': ['6rem', '1.15'],
			'10xl': ['8rem', '1.15'],

      '12': ['.75rem', '1rem'],
			'13': ['.8125rem', '1.25rem'],
			'14': ['.875rem', '1.25rem'],
			'15': ['.9375rem', '1.325rem'],
			'16': ['1rem', '1.5rem'],
			'18': ['1.125rem', '1.5rem'],
			'20': ['1.25rem', '1.75rem'],
			'22': ['1.375rem', '1.75rem'],
			'24': ['1.5rem', '1.75rem'],
			'26': ['1.625rem', '1.875rem'],
			'28': ['1.75rem', '1.875rem'],
			'30': ['1.875rem', '2rem'],
			'32': ['2rem', '2.25rem'],
			'36': ['2.25rem', '2.5rem'],
			'40': ['2.5rem', '1.15'],
			'44': ['2.75rem', '1.15'],
			'48': ['3rem', '1.15'],
			'60': ['3.75rem', '1.15'],
			'66': ['4.125rem', '1.15'],
			'72': ['4.5rem', '1.15'],
			'96': ['6rem', '1.15'],
			'100': ['6.25rem', '1.15'],
			'128': ['8rem', '1.15'],
    },
    extend: {
      aspectRatio: {
				'4/3': '4 / 3',
				'portrait': '3 / 4',
			},
      gridTemplateColumns: {
				'auto-1':		'repeat(1, auto)',
				'auto-2':		'repeat(2, auto)',
				'auto-3':		'repeat(3, auto)',
				'auto-4':		'repeat(4, auto)',
				'auto-5':		'repeat(5, auto)',
				'auto-6':		'repeat(6, auto)',
				'auto-7':		'repeat(7, auto)',
				'auto-8':		'repeat(8, auto)',
				'auto-9':		'repeat(9, auto)',
				'auto-10':		'repeat(10, auto)',
				'auto-11':		'repeat(11, auto)',
				'auto-12':		'repeat(12, auto)',

				'margins-4':	'[start] max(5vw, calc((100vw - theme("screens.3xl")) / 2)) [wrapperStart] repeat(2, 1fr) [mid columnMid wrapperMid] repeat(2, 1fr) [wrapperEnd] max(5vw, calc((100vw - theme("screens.3xl")) / 2)) [end]',

				'margins-12':	'[start] var(--container-margin) [containerStart] calc(var(--grid-margin) - var(--container-margin)) [wrapperStart] repeat(6, [columnLine] 1fr [columnLine]) [mid columnMid wrapperMid] repeat(6, [columnLine] 1fr [columnLine]) [wrapperEnd] calc(var(--grid-margin) - var(--container-margin)) [containerEnd] var(--container-margin) [end]',
      },
      gridTemplateRows:  {
				'auto-1':		'repeat(1, auto)',
				'auto-2':		'repeat(2, auto)',
				'auto-3':		'repeat(3, auto)',
				'auto-4':		'repeat(4, auto)',
				'auto-5':		'repeat(5, auto)',
				'auto-6':		'repeat(6, auto)',
      },
      gridColumnStart: {
				'wrapper': 'wrapperStart',
				'container': 'containerStart',
				'mid': 'mid',
				'first': '1',
				'line-1': 'columnLine 1',
				'line-2': 'columnLine 2',
				'line-3': 'columnLine 3',
				'line-4': 'columnLine 4',
				'line-5': 'columnLine 5',
				'line-6': 'columnLine 6',
				'line-7': 'columnLine 7',
				'line-8': 'columnLine 8',
				'line-9': 'columnLine 9',
				'line-10': 'columnLine 10',
				'line-11': 'columnLine 11',
				'line-12': 'columnLine 12',
			},
			gridColumnEnd: {
				'wrapper': 'wrapperEnd',
				'container': 'containerEnd',
				'mid': 'mid',
				'last': '-1',
				'line-1': 'columnLine 1',
				'line-2': 'columnLine 2',
				'line-3': 'columnLine 3',
				'line-4': 'columnLine 4',
				'line-5': 'columnLine 5',
				'line-6': 'columnLine 6',
				'line-7': 'columnLine 7',
				'line-8': 'columnLine 8',
				'line-9': 'columnLine 9',
				'line-10': 'columnLine 10',
				'line-11': 'columnLine 11',
				'line-12': 'columnLine 12',
			},
			gridRowStart: {
				'first': '1'
			},
			gridRowEnd: {
				'last': '-1'
			},
      colors: {
        'blue': {
          DEFAULT: '#0D1D41',
          100: '#25608C',
          200: '#38688C',
          300: '#1D4B6E',
          500: '#0D1D41',
          700: '#08132D'
        },
        'gold': {
          DEFAULT: '#BF9341',
          'bright': '#FFC629'
        }
      },
    },
  },
  plugins: [],
}
